import {config} from '@/profile-creation-wizard/config/applicationConfig';
import {ProfileCreationStepGroup} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import maltClassicRoutesConfig from '@/profile-creation-wizard/router/config/MaltClassicRoutesConfiguration';
import maltStrategyRoutesConfiguration from '@/profile-creation-wizard/router/config/MaltStrategyRoutesConfiguration';
import oldRoutesConfig from '@/profile-creation-wizard/router/config/OldRoutesConfiguration';
import ProfileCreationRouterHelper from '@/profile-creation-wizard/router/ProfileCreationRouterHelper';
import {createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized} from 'vue-router';

const routeAliasesForSignupStep = ['/creation'];

const routeAliasesForCompletionStep = ['/completion'];

const routesConfig = getRoutesConfig();

const router = createRouter({
    history: createWebHistory(config.baseUrl),
    linkActiveClass: 'active',
    routes: routesConfig.routes,
});

router.beforeEach((routeTo: RouteLocationNormalized, routeFrom: RouteLocationNormalized, next: NavigationGuardNext) => {
    const routeQuery = routeTo.query || {};

    if (
        ProfileCreationRouterHelper.needsRedirectionToFirstStepOfGroup(routesConfig, ProfileCreationStepGroup.SIGNUP, routeTo, routeFrom) ||
        ProfileCreationRouterHelper.routeIsAnAlias(routeTo, routeAliasesForSignupStep)
    ) {
        next({name: routesConfig.creationFirstStep, query: routeQuery, replace: true});
    } else {
        if (
            ProfileCreationRouterHelper.needsRedirectionToFirstStepOfGroup(routesConfig, ProfileCreationStepGroup.COMPLETION, routeTo, routeFrom) ||
            ProfileCreationRouterHelper.routeIsAnAlias(routeTo, routeAliasesForCompletionStep)
        ) {
            next({name: routesConfig.completionFirstStep, query: routeQuery, replace: true});
        }

        next();
    }
});

function getRoutesConfig() {
    if (ProfileCreationRouterHelper.isFeatureFlagFreelancerConvergenceSignupActivated(window.features)) {
        // Malt Strategy
        if (ProfileCreationRouterHelper.isFunnelModeStrategyActivated(new URLSearchParams(window.location.search))) {
            return maltStrategyRoutesConfiguration;
        }
        // Malt "classic" for freelancer
        return maltClassicRoutesConfig;
    }
    // Current funnel (if the FF is deactivated)
    return oldRoutesConfig;
}

export default router;
